<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KHUbox/tc-custom/9781338162905.jpg?1706728662542" alt="This image is the cover for the book Two Peas in a Pod, Whatever After"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Two Peas in a Pod, Whatever After
      </h1>
      <p class="bookDescription body article font2">
        <b>This hilarious novel in the <i>New York Times</i>–bestselling series fractures the beloved fairy-tale of The Princess and the Pea . . . </b><br/><br/>I’ve landed—along with my brother, Jonah, and our dog, Prince—on the other side of the portal . . . and in the fairy tale of The Princess and the Pea! When I can’t fall asleep on top of a hundred mattresses, the kingdom decides I must be the princess they’re looking for. Talk about royal treatment—I’m suddenly being waited on hand and foot. Plus, I get unlimited ball gowns, sparkly jewelry, and ice cream. But can we find a REAL princess to run the kingdom? Now we have to: Hold a princess contestDefeat an obnoxious princeEscape hungry alligatorsMake it back home <br/><br/>There’s no time to snooze—may the best princess win!<br/><br/><b>Praise for the series</b><br/><br/>“Uproariously funny . . . non-stop action . . . will enchant readers from the first page.” —<i>Kirkus Reviews</i><br/><br/>“A wonderful reading adventure.” —Meg Cabot, #1 <i>New York Times</i>–bestselling author of <i>The Princess Diaries</i><br/><br/>“Hilarious . . . unexpected plot twists and plenty of girl power.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sarah Mlynowski
      </h2>
      
      <p class="authorDescription body article"> Sarah Mlynowski is the <I>New York Times</I> bestselling author of the Whatever After series, the Magic in Manhattan series, <I>Best Wishes</I>, <I>Gimme a Call</I>, and a bunch of other books for teens and tweens, including the Upside-Down Magic series, which she cowrites with Lauren Myracle and Emily Jenkins and which was adapted into a movie for the Disney Channel. Originally from Montreal, Sarah now lives in Los Angeles with her family. Visit Sarah online at sarahm.com and find her on Instagram, Facebook, and Twitter at @sarahmlynowski. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Scholastic
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22c29b1c